export default __webpack_public_path__ + "static/media/ls-ehs-losses.76967e85.svg";